module.exports = __webpack_public_path__ + "img/air_empty.f6c12eb8.svg";